import React, { lazy } from 'react';
import { useRoutes } from 'react-router-dom';

import { ROUTE_REPORT_URL_PATH_NAME } from 'entities/reports';
import { SHARED_ROUTE_HISTORY_URL_PATH_NAME } from 'entities/cars';

import MainLayout from './MainLayout';
const Map = lazy(() => import('./pages/Map'));
const Report = lazy(() => import('./pages/Report'));
const RouteReport = lazy(() => import('./pages/RouteReport'));
const Mobile = lazy(() => import('./pages/Mobile'));
const SharedRouteHistory = lazy(() => import('./pages/SharedRouteHistory'));

const routeConfig = [{
    path: '/mobile',
    element: <Mobile />
}, {
  path: '/',
  element: <MainLayout />,
  children: [{
    path: 'report/:reportGuid',
    element: <Report />
  }, {
    path: `${ROUTE_REPORT_URL_PATH_NAME}/:reportGuid`,
    element: <RouteReport />
  }, {
    path: `${SHARED_ROUTE_HISTORY_URL_PATH_NAME}/:routeId`,
    element: <SharedRouteHistory />
  }, {
    path: '/',
    element: <Map />
  }, {
    path: '*',
    element: <Map />
  }]
}];

export const Routes = () => {
  // @ts-ignore
  const element = useRoutes(routeConfig);

  return (
    <>{element}</>
  );
};

export default Routes;